import * as React from 'react';

const EMail = (props: React.SVGProps<SVGSVGElement>) => (
  <svg {...props} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M15.833 15H4.16699C3.70699 15 3.33299 14.627 3.33299 14.167V6.04201L9.49999 10.667C9.64799 10.778 9.82399 10.833 9.99999 10.833C10.176 10.833 10.352 10.778 10.5 10.667L16.667 6.04201V14.167C16.667 14.627 16.292 15 15.833 15ZM15.277 5.00001L9.99999 8.95801L4.72299 5.00001H15.278H15.277ZM15.833 3.33301H4.16699C2.78799 3.33301 1.66699 4.45501 1.66699 5.83301V14.167C1.66699 15.545 2.78799 16.667 4.16699 16.667H15.833C17.212 16.667 18.333 15.545 18.333 14.167V5.83301C18.333 4.45501 17.212 3.33301 15.833 3.33301Z" fill="currentColor"/>
  </svg>
);

export default EMail;
